module.exports = __webpack_public_path__ + "img/tz_logo_red_slogan_final.770135cc.png";